<template>
<body v-show="startRender">
    <div class="round-result">
      <div class="close" id="win_list_close"></div>
      <ul class="list" id="win_list">
        <li v-for="(winInfo , index) in winList" :key="index">
          <div class="round-info">
            <div class="round-num">
              <div class="round">{{winInfo.winNo}}회차<span class="date">{{winInfo.winDate}}</span></div>
              <div class="join-total">{{winInfo.totalUserCnt}} 참여</div>
            </div>
            <div class="winner-reward">
              <div class="winner-total">
                <div class="reward-total"><span>{{winInfo.totalFus}}</span> FUS</div>
                <div class="winner-num">{{winInfo.winUserCnt}}명 ({{winInfo.totalFus}} / {{winInfo.winUserCnt}})</div>
              </div>
              <div class="win-num">{{winInfo.diceMaxSum}}</div>
            </div>
          </div>
          <ul class="winners">
            <li>
              <div class="user" v-for="(user , u_index) in winInfo.list" :key="u_index">
                <div class="profile" :style="`background-image: url(${user.userPhotoUrl}), url(/images/basic/img/default.svg) ;border-radius:50%`"></div>
                <!--<div class="profile" :style="`background-image: url(${user.userPhotoUrl == '' ? '/images/basic/img/default.svg' : user.userPhotoUrl}); border-radius:50%`"></div>-->
                <div class="infos">
                  <span class="id">{{user.userNm}}</span>
                  <span class="get">+{{user.winFus}}</span>
                </div>
              </div>
            </li>
          </ul>
        </li>
      </ul>  
    </div>
    <div class="help" >
      <div class="open" v-if="startRender">
        <template >
          <p style="white-space: inherit;">매일 00:00 ~ 23:50 까지 참여가능합니다.</p>
          <p>최고점수자는 23:50 ~ 24:00 사이에 확정됩니다.</p>
          <p>채굴된 FUS는 최고점수자 확정 후 바로 지급됩니다.</p>
          <p>보유한 채굴권을 소모하여 참여가 가능합니다.</p>
          <p>비정상적 방법을 이용한 경우 획득한 FUS는 모두 회수됩니다.</p>
        </template>
      </div>
      <a href="#" class="toggle"></a>
    </div>
    <a href="javascript:window.history.back();" class="close-this"><img src="images/btn/close-big-w.svg" alt=""></a>
    <div class="wrap">
      <div class="title">
        <h1><span>현재 </span><span class="cnt">{{totalFusView}}</span><span>Ⓕ</span></h1>
        <h2>최고숫자에게 몰빵 지급!</h2>
        <h3>00:00 ~ 23:50까지 참여한 숫자 x {{xFus}} Ⓕ</h3>
        <!-- <h4 class="remain"><span>06:58:32</span>후에 채굴권 획득 가능(보유: 24.55)</h4> -->
        <template v-if="check == true">
           <h4 class="remain"><span>채굴권 획득 가능!</span> <div class="get" @click="startNativeAd()">채굴권 받기</div></h4>
        </template>
        <template v-else>
           <h4 class="remain"><span>{{timeText}}</span>후에 채굴권 획득 가능</h4>
        </template>
      </div>
      <div class="dice-container" id="dice-container">
        <div :class="ticketCnt < 1? 'disable on': 'disable'">
          <h3>채굴권이 필요합니다.</h3>
          <p>채굴권은 앱내 다양한 활동으로<br>획득 가능합니다.</p>
          <div class="btns">
            <div class="impor" @click="startNativeAd()">채굴권 획득</div>
            <!-- <a href="#">채굴권 획득</a> -->
          </div>
        </div>
        <div class="info on" >
          <div id="info_div">
            <div class="center_field">
              <div id="label"></div>
            </div>
          </div>
          <div class="ment" >
            <div class="aod">
              <div class="img"><img src="images/img/dice.png" alt=""></div>
              <p class="guide-ment">주사위를 안으로 굴려보세요.(채굴권 1 소모)<br>보유 채굴권: {{ticketCntView}}</p>
            </div>
          </div>
        </div>
        <div id="selector_div" style="display: none">
          <div class="center_field">
            <div id="sethelp">
              choose your dice set by clicking the dices or by direct input of notation,<br>
              tap and drag on free space of screen or hit throw button to roll
            </div>
          </div>
          <div class="center_field">
            <input type="text" id="set" value="6d6" style="width: 6ex;">&gt;<br>
            <button id="clear">clear</button>
            <button style="margin-left: 0.6em" id="throw">throw</button>
          </div>
        </div>
        <div id="canvas" style="width: 375px; height: 375px;">
            <!--<canvas width="375" height="375" style="width: 375px; height: 375px;"></canvas>-->
        </div>
      </div>
      <div class="winner">
        <template v-if="winList.length > 0">
          <div class="win-info">
            <span class="round">{{winList[0].winNo}}회차 최고점수</span>
            <span class="score">{{winList[0].diceMaxSum}}</span>
          </div>
          <div class="winner-info">
            <span class="round">확정자 {{winList[0].winUserCnt}} </span>
            <span class="winners">{{winList[0].totalFus}} ÷ {{winList[0].winUserCnt}}Ⓕ 지급</span>
          </div>
          <div class="more">+</div>
        </template>
      </div>
      <div class="log">
        <div class="joiner">
          <p class="current">참여자 <span>{{resultCnt}}</span></p>
          <p class="high">현재 최고점수 <span>{{maxSum}}</span></p>
        </div>
        <ul class="list">
          <li v-for="(user, index) in userList" :key="index" :class="uniqId == user.uniqId ? `my`: ``">
              <div class="profile" :style="`background-image: url(${user.userInfo.myPhotoUrl}), url(/images/basic/img/default.svg) ;border-radius:50%`"></div>
              <div class="infos">
                <p>{{user.joinText}}</p>
              </div>
            </li>
        </ul>
      </div>
    </div>    
</body>
</template>

<script>
import Vue from 'vue';
import VueHead from 'vue-head';
import { timeCheck ,create, use, check } from '@/api/mining'
import { diceWinList } from '@/api/game'
import $ from 'jquery';
Vue.use(VueHead);
export default {
  head: {
    title: {
      inner: '더해-블록체인 커뮤니티 플랫폼'
    },
    meta: [
      { charset: 'UTF-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, viewport-fit=cover' },
      { name: 'apple-mobile-web-app-title', content: '더해' },
      { name: 'apple-mobile-web-app-capable', content: 'yes' },
      { name: 'msapplication-TileColor', content: '#ffffff' },
      { name: 'theme-color', content: '#ffffff' },
      { name: 'msapplication-TileImage', content: '/ms-icon-144x144.png' },
      { name: 'apple-mobile-web-app-status-bar-style', content: 'default' },
      { property: 'og:url"', content: '' },
      { property: 'og:title"', content: '더해' },
      { property: 'og:type"', content: 'website' },
      { property: 'og:image"', content: 'images/favicon/og.png' },
      { property: 'og:description"', content: '즐거움과 혜택이 더해지는 커뮤니티 플랫폼' },
    ],
    link: [
      { rel: 'stylesheet', type: 'text/css', href: 'stylesheets/dice.css' },
      { rel: 'apple-touch-icon', sizes: '57x57', href: 'images/favicon/apple-icon-57x57.png' },
      { rel: 'apple-touch-icon', sizes: '60x60', href: 'images/favicon/apple-icon-60x60.png' },
      { rel: 'apple-touch-icon', sizes: '72x72', href: 'images/favicon/apple-icon-72x72.png' },
      { rel: 'apple-touch-icon', sizes: '76x76', href: 'images/favicon/apple-icon-76x76.png' },
      { rel: 'apple-touch-icon', sizes: '114x114', href: 'images/favicon/apple-icon-114x114.png' },
      { rel: 'apple-touch-icon', sizes: '120x120', href: 'images/favicon/apple-icon-120x120.png' },
      { rel: 'apple-touch-icon', sizes: '144x144', href: 'images/favicon/apple-icon-144x144.png' },
      { rel: 'apple-touch-icon', sizes: '152x152', href: 'images/favicon/apple-icon-152x152.png' },
      { rel: 'apple-touch-icon', sizes: '180x180', href: 'images/favicon/apple-icon-180x180.png' },
      { rel: 'icon', type: 'image/png', sizes: '192x192', href: 'images/favicon/android-icon-192x192.png' },
      { rel: 'icon', type: 'image/png', sizes: '32x32', href: 'images/favicon/favicon-32x32.png' },
      { rel: 'icon', type: 'image/png', sizes: '96x96', href: 'images/favicon/favicon-96x96.png' },
      { rel: 'icon', type: 'image/png', sizes: '16x16', href: 'images/favicon/favicon-16x16.png' },
    ]
  },
  data() {
     return{
        startRender:false,

        totalFus:0,      // 총 참여된 FUS
        totalFusView:"", // 총 참여된 FUS 콤마처리
        ticketCntView:"",
        tempTicketCnt:0, // 내 티켓 카운트
        gameResult:[],   // 주사위 RESULT
        timeText:"",     // 채굴권 흭득 가능시간 TEXT
        second:0,        // 채굴권 흭득 가능시간 second
        check:false,     // ?TODO
        // under  참여자 관련정보
        userList:[],     // 참여자 list
        resultCnt:0,  // 촘 참여자수
        maxSum:0,        // 최고점수
        
        xFus:"", // ?TODO

        winList:[],

        win_page:1,
        win_rangeCnt:10
     }
  },
  created() {
    
    // remove common css 
  
    if($('link[href*="/stylesheets/reset.css"]')[0])$('link[href*="/stylesheets/reset.css"]')[0].remove();
    if($('link[href*="/stylesheets/style.css"]')[0])$('link[href*="/stylesheets/style.css"]')[0].remove();

    this.adTimeCheck();
    this.checkList();
    this.getDiceWinList();
  },
  mounted() { 
    window.VueRoot=this;

    $(function () {
      $('a[href="#"]').click(function (e) {
        e.preventDefault(); 
      });
      $(".help").click(function (e) {
        $(this).toggleClass("ed");
      });
      $(".winner").bind("click", function () {
        $(".round-result").addClass("on");
      });
      $(".round-result .close").click(function (e) {
        $(".round-result").removeClass("on");
      });
      $(".disable .btns a").click(function (e) {
        $(".disable").removeClass("on");
      });
      $(".modal-call").click(function (e) {
        e.preventDefault();
        $("body").addClass("modal-poped");
        var modalID = $(this).attr("rel");
        $("." + modalID).addClass("active");
      }); 
      $(".info").addClass("on");
      // win list [result list] bottom to load data
      const scroll_offset = 400;
      $("#win_list")[0].addEventListener('scroll', () => { 
        var scroll_height = $("#win_list")[0].scrollHeight;
        var clientHeight = $("#win_list")[0].clientHeight;
        if($("#win_list").scrollTop() > (scroll_height - clientHeight) - scroll_offset){
          window.VueRoot.getDiceWinList();
        }
      });
     });
  },
  computed: {
      uniqId(){
        return this.$store.state.userInfo.uniqId;
      },
      accountCoin(){
         var accountCoin = this.$store.state.userInfo.accountCoin == undefined ? 0 : this.$store.state.userInfo.accountCoin;
         return accountCoin;
      },
      ticketCnt(){
         if(this.$store.state.userInfo.ticketCnt == undefined){
            return 0;
         }else{
            return this.$store.state.userInfo.ticketCnt;
         }
      }
  },
  methods: {
    addScript() {
      let scripts = [
        'javascripts/js/jquery.min.js',
        'javascripts/js/three.min.js',
        'javascripts/js/cannon.min.js',
        'javascripts/js/teal.js',
        'javascripts/js/dice.js',
        'javascripts/js/main.js',
      ];

      for (let i = 0, len = scripts.length; i < len; i++) {
        let script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('src', scripts[i]);
        script.async = false;
        document
        .getElementsByTagName('body')[0]
        .appendChild(script)
      }
    },
    // dice method
    diceBeforeRoll(){
      console.log("start roll");
    },
    diceAfterRoll(result){
      this.gameResult = result;
      this.useTicket();
    },
    // end dice method
    startNativeAd(){
        var varUA = navigator.userAgent.toLowerCase();
        if ( varUA.indexOf('android') > -1) {
            //ANDDROID
            try{
               window.Android.platInterstitialAd("AD4");
            }catch{
               window.Android.playRewardAd();  
            } 
        } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
            window.webkit.messageHandlers.platInterstitialAd.postMessage("AD4");
            //IOS
            //playSpin();
        } else {
            //아이폰, 안드로이드 외
            //playSpin();
        }
     },
     adTimeCheck(){
        timeCheck({
           adType:"AD4"
        })
        .then(({ data }) => {
           //this.timeText = data.timeText;
           this.check = data.check;
           this.second = data.second;
           if(this.second>0){
              this.uiSetTimeText(); 
           }
        })
     },
     uiSetTimeText(){
        this.interval = setInterval(function(){
	        window.VueRoot.second--;
           var sec_num = window.VueRoot.second; // don't forget the second param
           var hours   = Math.floor(sec_num / 3600);
           var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
           var seconds = sec_num - (hours * 3600) - (minutes * 60);
           if (hours   < 10) {hours   = "0"+hours;}
           if (minutes < 10) {minutes = "0"+minutes;}
           if (seconds < 10) {seconds = "0"+seconds;}
           var timeTextStr = hours+":"+minutes+":"+seconds;
           window.VueRoot.timeText = timeTextStr;
           if(sec_num < 0) {
              clearInterval(window.VueRoot.interval);
              window.VueRoot.adTimeCheck();
           }
	     },1000);
     },
     useTicket(){
        use({
           gameType:"dice",
           resultNum:"["+this.gameResult+"]"
        })
        .then(({ data }) => {
          if(data.resultCode == 3500){
            alert("참여할 수 없는 시간입니다.");
            return;
          }
          this.tempTicketCnt = data.ticketCnt;
          this.ticketCntView = data.ticketCntView;
          window.VueRoot.$store.commit('udtTicketCnt', window.VueRoot.tempTicketCnt);
          window.VueRoot.checkList(); 
        })
     },
     /**
      * 모바일에서 광고 시청이 완료되었을때 불리는 function
      * do ticket add rest ful apu call
      * native => Vue 
      * @adType = "AD1","AD2","AD3" // 해당 값은 일단 유동적으로
      *            각게임마다 정해진 AD<NUM> 사용해볼것
      */
     addTicketCnt(adType){
        create({
           adType:"AD4"
        })
        .then(({ data }) => {
           this.$store.commit('udtTicketCnt', data.ticketCnt);
           this.adTimeCheck();
           this.checkList(); 
        })
     },
     /**
      * 채굴권 갯수 확인 및 참여리스트 
      */
     checkList(){
        check({
           gameType:"dice"
        })
        .then(({ data }) => {
          //data.resultCode = 3500
          if(data.resultCode == 3500){
            alert("참여할 수 없는 시간입니다.");
          }
          console.log(data);

          this.ticketCntView = data.ticketCntView;
          this.accountCoin = data.accountCoin;
          this.maxSum = data.maxSum;
          this.resultCnt = data.resultCnt;
          this.totalFusView = data.totalFusView;
          this.userList = data.resultList;
          this.xFus = data.xFus;
          
          if(!this.startRender)this.addScript();
          this.startRender = true;
           
        })
     },
    /**
     * 게임 결과목록
     */
    getDiceWinList(){
      diceWinList({
        pageIndex:this.win_page++,
        recodrdCntOnPage:this.win_rangeCnt
      })
      .then(({ data }) => {
          data.resultList.forEach(element => {
            this.winList.push( element );
          });
      })
    }
   }
}
</script>

<style>

</style>